import { Fragment } from "react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/common/table/Table";
import Typography from "@/shared/components/common/Typography";

import json from "@/public/data/footerPages.json";

interface RefundRulesMobileProps {
  rule: RefundRule;
}

export const CancelRulesMobileCard = ({ rule }: RefundRulesMobileProps) => {
  const {
    refundRules: { rateId, allRateId, PenaltyPercentage },
  } = json;

  const { descriptions, data } = rule;

  return (
    <Table className="text-center py-2">
      <TableHeader className="py-4 bg-slate-100">
        <TableRow className="border-none">
          <TableHead className="text-center py-3 px-3">{rateId}</TableHead>
          <TableHead className="text-center py-3 px-3 ">
            {PenaltyPercentage}
          </TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {data.map(({ data, rate_id }) => (
          <Fragment key={rate_id}>
            <TableRow>
              <TableCell className="!py-6">
                <Typography className="break-words">
                  {rate_id || allRateId}
                </Typography>
              </TableCell>
            </TableRow>

            {data.map((cell, index) => (
              <TableRow key={`cell-${index}`}>
                <TableCell className="!py-6">{descriptions[index]}</TableCell>
                <TableCell className="!py-6">
                  {cell ? cell + "%" : "_"}
                </TableCell>
              </TableRow>
            ))}
          </Fragment>
        ))}
      </TableBody>
    </Table>
  );
};
